import { useEffect } from 'react';

const DocTitleScrollTop = docTitle => {
	return useEffect(() => {
		window.scrollTo(0, 0);
		document.title = `${docTitle} | Socialize`;
	}, [docTitle]);
};

export default DocTitleScrollTop;
